"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disconnectWeb3 = exports.solConnect = exports.cosmosConnect = exports.ethConnect = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./lib/auth-browser"), exports);
// -- all the chains you can connect to
exports.ethConnect = require("./lib/chains/eth");
exports.cosmosConnect = require("./lib/chains/cosmos");
exports.solConnect = require("./lib/chains/sol");
var eth_1 = require("./lib/chains/eth");
Object.defineProperty(exports, "disconnectWeb3", { enumerable: true, get: function () { return eth_1.disconnectWeb3; } });
// -- session management
tslib_1.__exportStar(require("./lib/session"), exports);
//# sourceMappingURL=index.js.map